export default [
  //COUNCIL PROFILE
  {
    path: '/coupons',
    name: 'coupon',
    component: () => import('@/views/coupon/Index.vue'),
    meta: {
      resource: 'Coupon',
      action: 'read',
      pageTitle: 'Coupon Management',
      breadcrumb: [
        {
          text: 'Coupon Management',
          active: true
        }
      ],
    },
  }
]
